import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {deleto, get, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

// Create group
export function* createProductGroupRequest() {
    yield takeEvery(actions.PRODUCT_GROUP_CREATE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/products/groups', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PRODUCT_GROUP_CREATE_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.PRODUCT_GROUP_CREATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createProductGroupSuccess() {
    yield takeEvery(actions.PRODUCT_GROUP_CREATE_SUCCESS, function* () {
        yield message.success(t`The product group is created.`);
    });
}
export function* createProductGroupError() {
    yield takeEvery(actions.PRODUCT_GROUP_CREATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read group list
export function* readProductGroupListRequest() {
    yield takeEvery(actions.PRODUCT_GROUP_READ_LIST_REQUEST, function* (action, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/products/groups', null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PRODUCT_GROUP_READ_LIST_SUCCESS,
                groups: data.groups,
            });
        }
        catch (error) {
            yield put({
                type: actions.PRODUCT_GROUP_READ_LIST_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readProductGroupListSuccess() {
    yield takeEvery(actions.PRODUCT_GROUP_READ_LIST_SUCCESS, () => {});
}
export function* readProductGroupListError() {
    yield takeEvery(actions.PRODUCT_GROUP_READ_LIST_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read group
export function* readProductGroupRequest() {
    yield takeEvery(actions.PRODUCT_GROUP_READ_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/products/groups/${id}`, null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PRODUCT_GROUP_READ_SUCCESS,
                group: data.group,
            });
        }
        catch (error) {
            yield put({
                type: actions.PRODUCT_GROUP_READ_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readProductGroupSuccess() {
    yield takeEvery(actions.PRODUCT_GROUP_READ_SUCCESS, () => {});
}
export function* readProductGroupError() {
    yield takeEvery(actions.PRODUCT_GROUP_READ_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update group
export function* updateProductGroupRequest() {
    yield takeEvery(actions.PRODUCT_GROUP_UPDATE_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, `/products/groups/${id}`, request, context);

            // OK
            yield put({
                type: actions.PRODUCT_GROUP_UPDATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.PRODUCT_GROUP_UPDATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateProductGroupSuccess() {
    yield takeEvery(actions.PRODUCT_GROUP_UPDATE_SUCCESS, function* () {
        yield message.success(t`The product group is updated.`);
    });
}
export function* updateProductGroupError() {
    yield takeEvery(actions.PRODUCT_GROUP_UPDATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete group
export function* deleteProductGroupRequest() {
    yield takeEvery(actions.PRODUCT_GROUP_DELETE_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/products/groups/${id}`, null, context);

            // OK
            yield put({
                type: actions.PRODUCT_GROUP_DELETE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.PRODUCT_GROUP_DELETE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteProductGroupSuccess() {
    yield takeEvery(actions.PRODUCT_GROUP_DELETE_SUCCESS, function* () {
        yield message.success(t`The product group is deleted.`);
    });
}
export function* deleteProductGroupError() {
    yield takeEvery(actions.PRODUCT_GROUP_DELETE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(createProductGroupRequest),
        fork(createProductGroupSuccess),
        fork(createProductGroupError),
        fork(readProductGroupListRequest),
        fork(readProductGroupListSuccess),
        fork(readProductGroupListError),
        fork(readProductGroupRequest),
        fork(readProductGroupSuccess),
        fork(readProductGroupError),
        fork(updateProductGroupRequest),
        fork(updateProductGroupSuccess),
        fork(updateProductGroupError),
        fork(deleteProductGroupRequest),
        fork(deleteProductGroupSuccess),
        fork(deleteProductGroupError),
    ]);
}
